var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-view',{ref:"listView",attrs:{"title":"Tipos de Productos","entity":"producttype","showExportBtn":false,"showSearch":false,"showNewBtn":false,"showListType":false,"pagerequest":_vm.pagerequest,"columns":_vm.columns}})}
var staticRenderFns = []

export { render, staticRenderFns }